module.exports = __webpack_public_path__ + "img/bannerMeomory.4795e4a6.jpg";